module.exports = __webpack_public_path__ + "img/img_cs_banner.0c5fab98.png";